<template>
  <div class="mainContainer normalText header" id="customer-detail" v-if="customer[0]" v-loading="fullPageLoading">
    <el-row class="section">
      <el-col :span="18" class="dp-flex">
        <div class="header-36-black">คนไข้</div>
        <div class="header-36-white mgl-14 mgr-21">P{{ id }}</div>
        <img v-if="lineIdCheck" src="https://storage.healthathome.in.th/a9852723-b5dd-4633-b843-4b3dd6c8e942.svg" class="mgt-3 active" alt="chat" height="35" width="35" @click="gotoChat">
        <img v-else src="@/assets/icon/chat-disable.svg" class="mgt-3 disabled" alt="chat" height="35" width="35">
      </el-col>
    </el-row>
    <el-row class="section" v-if="customer !== null">
      <el-row>
        <div class="group-horizontal">
          <div class="smallText gray bold">ชื่อผู้ติดต่อ &nbsp;</div>
          <div class="smallText gray normal">&nbsp; {{ customer[0].contact.name }}</div>
        </div>
      </el-row>
      <el-row>
        <div class="group-horizontal">
          <div class="smallText gray bold">ชื่อคนไข้ &nbsp;</div>
          <div class="smallText gray normal">&nbsp; {{ customer[0].name }}</div>
        </div>
      </el-row>
    </el-row>
    <el-row class="section">
      <el-tabs v-model="tabSelected" @tab-click="handleClick">
        <el-tab-pane label="ข้อมูล" name="patientinfoTab" />
        <el-tab-pane label="ตารางเวร" name="workcalendarTab" />
        <el-tab-pane label="การดูแล" name="careprogressTab" />
        <el-tab-pane label="คอมเมนต์" name="commentTab" />
      </el-tabs>
      <div v-if="tabSelected==='patientinfoTab' && customer[0]" class="patient-detail">
        <div class="buton-container"><div :class="['button', { 'dark-gray' : page === 1}]" @click="changePage(-1)" v-if="page !== 0 && customer.length > 1" /></div>
        <div style="width: 100%;">
          <sectionContact :sectionData="customer[page]" :historiesData="historiesData" @editButtonClick="editButtonClick" :isHistory="page !== 0" />
          <sectionPatient :sectionData="customer[page]" :historiesData="historiesData" :enableUpload="true" :isHistory="page !== 0" :getCustomer="getCustomer" />
        </div>
        <div class="buton-container right"><div class="button" @click="changePage(+1)" v-if="page !== customer.length - 1  && customer.length > 1" /></div>
      </div>
      <patientCalendar v-if="tabSelected==='workcalendarTab'" :patientId="id" />
      <patientComment v-if="tabSelected==='commentTab'" :patientId="id" />
      <patientCareProgress v-if="tabSelected==='careprogressTab'" :patientId="id" />
    </el-row>
  </div>
</template>

<style lang="scss">
  .el-tabs__item {
    font-family: 'Sukhumvit-SemiBold';
    font-weight: 600;
    color: #606266;
    font-size: 24px;
    margin-bottom: 2px;
  }
</style>

<style lang="scss" scoped>

  .bold {
    font-family: 'Sukhumvit-SemiBold';
  }

  .normal {
    font-family: 'Sukhumvit';
    font-weight: 100;
  }

  .dp-flex {
    display: flex;
  }

  .mgl-14 {
    margin-left: 14px;
  }

  .mgr-21 {
    margin-right: 21px;
  }

  .mgt-3 {
    margin-top: 3px;
  }

  .active {
    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  }

  .disabled {
    &:hover {
      cursor: not-allowed;
    }
  }

  .gray {
    color: #A2A7B2;
  }

  .mainContainer {
    padding: 20px 100px 100px;
  }

  .smallContainer {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .normalText {
    font-size: 18px;
    line-height: 1.5;
    color: #303133;
  }

  .right {
    text-align: right;
  }

  .smallText {
    font-size: 14px;
  }

  .section {
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;
  }

  .el-button {
    width: 120px;
  }

  .grayBackground {
    background: #F1F3F6;
  }

  .header {
    padding-bottom: 20px;
    padding-top: 155px;
    font-size: 22px;
    font-weight: 600;
    color: #606266;
  }

  .group-horizontal {
    display: flex;
    flex-direction: row;
  }

  .patient-detail {
    margin-left: -140px;
    margin-right: -140px;
    display: flex;
    flex-direction: row;

    .buton-container {
      min-width: 140px;
      max-width: 140px;
      display: flex;
      justify-content: flex-start;

      &.right {
        justify-content: flex-end;
      }

      .button {
        width: 100px;
        height: 100%;
        background: #F9F9FA;

        &.dark-gray {
          background: #F1F3F6;
        }

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
</style>

<script>
import PatientModel from '@/model/PatientModel'
import patientCalendar from '@/components/patient/PatientCalendar'
import patientComment from '@/components/patient/PatientComment'
import patientCareProgress from '@/components/patient/PatientCareProgress'
import sectionContact from '@/components/shared/SectionContact'
import sectionPatient from '@/components/shared/SectionPatient'
import { GenericAPIHandler } from '@/components/shared/GenericAPIHandler'

export default {
  name: 'PatientDetail',
  mixins: [GenericAPIHandler],
  components: {
    sectionPatient,
    sectionContact,
    patientCalendar,
    patientComment,
    patientCareProgress,
  },
  mounted () {
    this.getCustomer()
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      customer: [],
      dialogFormVisible: false,
      fullPageLoading: false,
      tabSelected: '',
      page: 0,
    }
  },
  computed: {
    lineIdCheck: function () {
      const line = this.customer[0].lineId
      return line.length === 33 && line[0] === 'U'
    },
    historiesData: function () {
      return this.page >= this.customer.length - 1 ? [] : this.customer[this.page + 1].different
    },
  },
  methods: {
    async getCustomer () {
      try {
        this.tabSelected = this.$route.query.tab
        this.fullPageLoading = true
        const raw = await this.$api.Patient.get(this.id)
        this.customer = []
        this.customer.push(PatientModel.fromJSON(raw).transformToDisplayable())
        for (let i = 0; i < raw.histories.length; i++) {
          let c = PatientModel.fromJSON(raw.histories[i]).transformToDisplayable()
          this.customer.push(c)
        }
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullPageLoading = false
      }
    },
    editButtonClick () {
      this.$router.push({ name: 'PatientEdit', params: { id: this.id } })
    },
    gotoChat () {
      this.$router.push({ name: 'ChatBoard', query: { id: this.customer[0].lineId } })
    },
    handleClick (tab, event) {
      this.$router.push({ name: 'PatientDetail', params: { id: this.id }, query: { tab: tab.name } })
    },
    changePage (tranform) {
      this.page = this.page + tranform
    },
  },
}
</script>
